import { configClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type { MyPreferences, MyPreferencesWire } from '../types/my-preferences.types';

/** Maps the snake_case wire row to the camelCase domain shape. */
function toPreferences(w: MyPreferencesWire): MyPreferences {
  return { showCostInUi: w.show_cost_in_ui, updatedAt: w.updated_at };
}

/** Fetches the signed-in user's own preferences (defaults until first saved). */
export async function fetchMyPreferences(): Promise<MyPreferences> {
  const wire = await configClient.get(endpoints.myPreferences.detail()).json<MyPreferencesWire>();
  return toPreferences(wire);
}

/** Partial update of the signed-in user's own preferences; returns the saved row. */
export async function updateMyPreferences(
  values: Partial<Pick<MyPreferences, 'showCostInUi'>>,
): Promise<MyPreferences> {
  const wire = await configClient
    .put(endpoints.myPreferences.detail(), {
      json: values.showCostInUi === undefined ? {} : { show_cost_in_ui: values.showCostInUi },
    })
    .json<MyPreferencesWire>();
  return toPreferences(wire);
}
